import activities from '@/api/activities';
import archive from '@/api/archive';
import booking from '@/api/booking';
import department from '@/api/department';
import gallery from '@/api/gallery';
import meal from '@/api/meal';
import meetings from '@/api/meetings';
import news from '@/api/news';
import profiles from '@/api/profiles';
import tts from '@/api/tts';
import workSchedule from '@/api/workSchedule';

export default {
  activities,
  archive,
  booking,
  department,
  gallery,
  meal,
  meetings,
  news,
  profiles,
  tts,
  workSchedule,
};
